export const References = (props) => {
  return (
    <div id='references'>
      <div className='container'>
        <div className='section-title text-center'>
          <h2>References</h2>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-4'>
                  <div className='reference'>
                    <div className='reference-image'>
                      {' '}
                      <img src={d.img} alt='' />{' '}
                    </div>
                    <div className='reference-content'>
                      <p>"{d.text}"</p>
                      <div className='reference-meta'> - {d.name} </div>
                    </div>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
